module.exports = __webpack_public_path__ + "static/img/pic3.738d211a.png";